import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#f7be21',
  secondary: '#5fc5c2',
  accent: '#673ab7',
  error: '#f44336',
  warning: '#ffc107',
  info: '#3c7870',
  success: '#4caf50'
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
